import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure and report web vitals for performance monitoring
// You can send these metrics to an analytics service
if (process.env.NODE_ENV === "production") {
  reportWebVitals((metric) => {
    // In production, you can send metrics to your analytics service
    // Example: sendToAnalytics(metric);
  });
}
